<template>
    <div>
        <BlogHeader :index = "'2'"></BlogHeader>
        <div class="cards" v-bind:class="{ showing: showIng }"  v-loading="loading" v-bind:style="{ marginBottom: cardsHeight }">
            <div class="card" @click="showDetail(index)" v-bind:class="{ show: showIngs[index] }" v-bind:style="{ zIndex: zIndex[index] }" v-for="(item,index) in list">
                <img v-lazy="'http://img.fang99.cc/'+item.pic" :key="item.pic" />
                <div class="card-title">
                    <a href="#" class="toggle-info btn">
                        <span class="left"></span>
                        <span class="right"></span>
                    </a>
                    <h2>
                        {{item.title|handle_str(1,17)}}
                        <small><i class="el-icon-view"></i>{{item.addtime|handle_str(2)}}</small>
                    </h2>
                </div>
                <div class="card-flap flap1">
                    <div class="card-description">
                        {{item.intro}}
                    </div>
                    <div class="card-flap flap2">
                        <div class="card-actions">
                            <a :href="'/#/detail/'+item.id" class="btn">{{$t('detail')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align: center;margin-bottom: 20px;">
            <el-pagination
                    @current-change="handleChange"
                    :current-page.sync="currentPage"
                    :page-size="12"
                    background
                    layout="prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        </div>
        <BlogFoot></BlogFoot>
    </div>
</template>

<script>
    import BlogHeader from './common/BlogHeader.vue';
    import BlogFoot from './common/BlogFoot.vue';
    import common from '../config/common.js';

    export default {
        name: "itList",
        data () {
            return {
                showIng:false,
                loading:true,
                showIngs:[false,false,false,false,false,false,false,false,false],
                zIndex:[10,10,10,10,10,10,10,10,10],
                index:'2',
                list:[],
                total:0,
                currentPage:1,
                cardsHeight:'60px'
            }
        },components:{
            BlogFoot,
            BlogHeader
        },
        methods:{
            handleScroll(){
                alert();
            },
            showDetail(index){
                this.zIndex = [10,10,10,10,10,10,10,10,10];
                ++this.zIndex[index];
                if(this.showIng){
                    if(this.showIngs[index])this.showIng=false;
                }
                else {
                    this.showIng=true;

                }
                if(this.showIngs[index]){
                    this.showIngs[index]=false;
                }
                else {
                    this.showIngs = [false,false,false,false,false,false,false,false,false];
                    this.showIngs[index]=true;
                }
            },getList(num){
                this.showIngs = [false,false,false,false,false,false,false,false,false];
                this.zIndex = [10,10,10,10,10,10,10,10,10];
                this.showIng = false;
                this.loading = true;
                if(this.$cookie.get('itlist'+num)){
                    this.list = JSON.parse(this.$cookie.get('itlist'+num));
                    this.total = JSON.parse(this.$cookie.get('ittotal'));
                    this.loading = false;
                }else{
                    this.$axios.get(common.apiurl+'/api/list/1/6?page='+num).then((response)=>{
                        if(response.data.code==0){
                            this.list = response.data.data.data;
                            this.loading = false;
                            this.total = response.data.data.total;
                            this.$cookie.set('itlist'+num,JSON.stringify(this.list), 1);
                            this.$cookie.set('ittotal',JSON.stringify(this.total), 1);
                        }
                        else {
                            this.$message({
                                message: this.$t('common.neterror'),
                                type: 'warning'
                            });
                        }
                    }).catch((error)=>{
                        this.$message({
                            message: this.$t('common.neterror'),
                            type: 'warning'
                        });
                    });
                }

            },handleChange(val){
                window.scrollTo(0,0);
                this.getList(val);
            }
        },created(){
            window.scrollTo(0,0);
            if(window.innerWidth>1910)this.cardsHeight='-50px';
            this.getList(1)
        }
    }
</script>

<style scoped>
    a.btn {
        background: #AF441E;
        border-radius: 4px;
        box-shadow: 0 2px 0px 0 rgba(0, 0, 0, 0.25);
        color: #ffffff;
        display: inline-block;
        padding: 6px 30px 8px;
        position: relative;
        text-decoration: none;
        -webkit-transition: all 0.1s 0s ease-out;
        transition: all 0.1s 0s ease-out;
    }
    .no-touch a.btn:hover {
        background: #AF441E;
        box-shadow: 0px 8px 2px 0 rgba(0, 0, 0, 0.075);
        -webkit-transform: translateY(-2px);
        transform: translateY(-2px);
        -webkit-transition: all 0.25s 0s ease-out;
        transition: all 0.25s 0s ease-out;
    }
    .no-touch a.btn:active,
    a.btn:active {
        background: #AF441E;
        box-shadow: 0 1px 0px 0 rgba(255, 255, 255, 0.25);
        -webkit-transform: translate3d(0, 1px, 0);
        transform: translate3d(0, 1px, 0);
        -webkit-transition: all 0.025s 0s ease-out;
        transition: all 0.025s 0s ease-out;
    }
    div.cards {
        text-align: center;
        margin-top: 120px;
        min-height: 700px;
    }
    div.card {
        background: whitesmoke;
        display: inline-block;
        margin: 8px;
        max-width: 300px;
        -webkit-perspective: 1000;
        perspective: 1000;
        position: relative;
        text-align: left;
        -webkit-transition: all 0.3s 0s ease-in;
        transition: all 0.3s 0s ease-in;
        z-index: 1;
    }
    div.card img {
        width: 300px;
        height: 225px;
    }
    div.card div.card-title {
        background: #ffffff;
        padding: 6px 15px 10px;
        position: relative;
        z-index: 0;
    }
    div.card div.card-title a.toggle-info {
        border-radius: 32px;
        height: 32px;
        padding: 0;
        position: absolute;
        right: 15px;
        top: 10px;
        width: 32px;
    }
    div.card div.card-title a.toggle-info span {
        background: #ffffff;
        display: block;
        height: 2px;
        position: absolute;
        top: 16px;
        -webkit-transition: all 0.15s 0s ease-out;
        transition: all 0.15s 0s ease-out;
        width: 12px;
    }
    div.card div.card-title a.toggle-info span.left {
        right: 14px;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
    }
    div.card div.card-title a.toggle-info span.right {
        left: 14px;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
    }
    div.card div.card-title h2 {
        font-size: 15px;
        font-weight: 700;
        color: #333;
        letter-spacing: -0.05em;
        margin: 0;
        padding: 0;
    }
    div.card div.card-title h2 small {
        display: block;
        font-size: 13px;
        color: #999;
        font-weight: lighter;
    }
    div.card div.card-description {
        padding: 0 15px 10px;
        position: relative;
        font-size: 14px;
    }
    div.card div.card-actions {
        box-shadow: 0 2px 0px 0 rgba(0, 0, 0, 0.075);
        padding: 10px 15px 20px;
        text-align: center;
    }
    div.card div.card-flap {
        background: #d9d9d9;
        position: absolute;
        width: 100%;
        -webkit-transform-origin: top;
        transform-origin: top;
        -webkit-transform: rotateX(-90deg);
        transform: rotateX(-90deg);
    }
    div.card div.flap1 {
        -webkit-transition: all 0.3s 0.3s ease-out;
        transition: all 0.3s 0.3s ease-out;
        z-index: -1;
    }
    div.card div.flap2 {
        -webkit-transition: all 0.3s 0s ease-out;
        transition: all 0.3s 0s ease-out;
        z-index: -2;
    }
    div.cards.showing div.card {
        cursor: pointer;
        opacity: 0.6;
        -webkit-transform: scale(0.88);
        transform: scale(0.88);
    }
    .no-touch div.cards.showing div.card:hover {
        opacity: 0.94;
        -webkit-transform: scale(0.92);
        transform: scale(0.92);
    }
    div.card.show {
        opacity: 1 !important;
        -webkit-transform: scale(1) !important;
        transform: scale(1) !important;
    }
    div.card.show div.card-title a.toggle-info {
        background: #ff6666 !important;
    }
    div.card.show div.card-title a.toggle-info span {
        top: 15px;
    }
    div.card.show div.card-title a.toggle-info span.left {
        right: 10px;
    }
    div.card.show div.card-title a.toggle-info span.right {
        left: 10px;
    }
    div.card.show div.card-flap {
        background: #ffffff;
        -webkit-transform: rotateX(0deg);
        transform: rotateX(0deg);
    }
    div.card.show div.flap1 {
        -webkit-transition: all 0.3s 0s ease-out;
        transition: all 0.3s 0s ease-out;
    }
    div.card.show div.flap2 {
        -webkit-transition: all 0.3s 0.2s ease-out;
        transition: all 0.3s 0.2s ease-out;
    }
    .el-breadcrumb{
        position:fixed;
        z-index:999;
        width: 100%;
        top:80px;
        margin-left: 6%;
    }
</style>


// WEBPACK FOOTER //
// src/components/ItList.vue